import { AxiosRequestConfig } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { ApiError, PayHistory } from '@types';
import { config } from '../../config';
import moment from 'moment';

export const fetchPayHistoryAsync = createAsyncAction(
    [
        'payhistory/FETCH_PAY_HISTORY_REQUEST',
        (accountNumber: string) => {
            return {
                url: `${config.env('awsUrl')}/api/v1/selfserv/loans/${accountNumber}/payments/history`,
                method: 'get',
                params: {
                    startDate: moment().subtract(3, 'months').format('YYYY-MM-DD'),
                    endDate: moment().format('YYYY-MM-DD')
                }
            } as AxiosRequestConfig;
        }
    ],
    ['payhistory/FETCH_PAY_HISTORY_SUCCESS', (response: PayHistory) => response],
    ['payhistory/FETCH_PAY_HISTORY_FAILURE', (error: ApiError) => error],
    'payhistory/FETCH_PAY_HISTORY_CANCEL'
)();
